export default __webpack_public_path__ + "static/media/image1.44b3bf42.jpg";